<template>
    <div class="InfoMain">
        <p class="current">当前位置：<span>订单详情</span></p>
        <div class="MainInfoSelf">
            <div class="InfoSelf-box">
                <p>订单编号</p>
                <span>{{ vsData.order_no }}</span>
            </div>
            <div>
                <div  class="InfoSelf-box" :style="!(vsData.ispay=='1') ? 'border: none;': ''">
                    <p>下单时间</p>
                    <span>{{ vsData.create_time }}</span>
                </div>
                <div  class="InfoSelf-box" v-if="(vsData.ispay=='1')" :style="(vsData.isconfirm!='1') ? 'border: none;': ''">
                    <p>付款时间</p>
                    <span>{{ vsData.pay_time }}</span>
                </div>
                <div class="InfoSelf-box" style="border: none;height: 30px;">
                    <div >
                        <div class="orderProvince">
                            <p>{{ vsData.province_name }}</p>
                            <p>{{ vsData.city_name }}</p>
                            <p>{{ vsData.county_name }}</p>
                            <p>{{ vsData.address }}</p>
                        </div>
                        <p style="margin-top: 10px;">{{ vsData.phone }}</p>

                    </div>
                </div>
                <div class="InfoSelf-box" v-if="(vsData.isconfirm=='1')" style="margin-top: -50px;">
                   
                    <div class="orderProvince">
                        <p>{{ vsData.contact }}</p>
                        <p>{{ vsData.phone }}</p>
                    </div>
                </div>
                <div class="InfoSelf-img" v-if="vsData.order_items != ''" >
                    <div v-if="vsData.order_items != ''" :style="'width: 150px; height: 90px;margin-right: 30px;background-image:url('+vsData.order_items[0].firstFile.FileUrl+');background-size: cover;background-repeat: no-repeat;background-position: center;'"></div>
                    
                    <div class="Info-name">
                        <p>{{ vsData.order_items[0].product_name }}</p>
                        <p class="num"><span>{{ vsData.order_items[0].atts_items_names }}，</span></p>
                        <p class="num">{{ vsData.order_items[0].price }} <span>x{{  vsData.order_items[0].amount }}</span> </p>
                    </div>
                </div>
            </div>
            <div class="invoiceCss" style="display: block;" v-show="invoiceAddress != ''">
                <p>发票信息</p>
                <div class="invoice_box" style="margin-top: 30px;">
                    <div>
                        <p>发票抬头</p>
                        <span>{{ invoiceInfo.name }}</span>
                    </div>
                    <div>
                        <!-- 1企业 -->
                        <p>发票类型</p> 
                        <span>{{ invoiceInfo.invoice_type == 1?'企业':'个人' }}</span>
                    </div>
                    <div>
                        <p>邮箱</p>
                        <span>{{ invoiceInfo.email }}</span>
                    </div>
                    <div v-if="invoiceInfo.invoice_type == 1">
                        <p>纳税人识别号</p>
                        <span>{{ invoiceInfo.identification }}</span>
                    </div>
                </div>
            </div>
            <div class="InfoSelf-box" style="height: 120px;display: block;" v-show="invoiceAddress != ''">
                <p>发票地址</p>
                <div style="margin-top: 30px;">
                        <div class="orderProvince">
                            <p>{{ invoiceAddress.province_name }}</p>
                            <p>{{ invoiceAddress.city_name }}</p>
                            <p>{{ invoiceAddress.county_name }}</p>
                            <p>{{ invoiceAddress.address }}</p>
                        </div>
                        <p style="margin-top: 10px;">{{ vsData.phone }}</p>

                    </div>
            </div>
            <div  class="InfoSelf-box" v-show="false">
                <p>商品金额</p>
                <span>￥{{ vsData.ptotal }}</span>
            </div>
            <div  class="InfoSelf-box" v-show="false">
                <p>运费</p>
                <span>￥{{ vsData.express_fee }}</span>
            </div>
            <div  class="InfoSelf-box" v-if="vsData.coupon_item_facevalue>0">
                <p>优惠券</p>
                <span>-{{ vsData.coupon_item_facevalue }}</span>
            </div>
            <div  class="InfoSelf-box">
                <p>余额支付</p>
                <span>-{{ vsData.use_user_money }}</span>
            </div>
            <div  class="InfoSelf-box">
                <p>订单总计</p>
                <span>￥{{ vsData.total }}</span>
            </div>
            <div  class="InfoSelf-box" v-if="(vsData.ispay=='1')">
                <p>使用积分</p>
                <span>-{{ vsData.use_profit_jifen }}</span>
            </div>
            <div class="InfoSelf-box">
                <p>实付金额</p>
                <span>￥{{ vsData.ptotal }}</span>
            </div>
            <!-- <div  class="InfoSelf-box" v-show="false">
                <p>支付方式</p>
                <span>微信支付</span>
            </div> -->
            <div class="InfoSelf-wuliu">
                <p>物流信息</p>
                <div v-if="vspn==0">
                    <p class="vstips">亲，暂无物流信息~</p>
                </div>
                
               
                <div  v-if="order_express.length>0"  v-for="(item,index) in expressList" :key="index">
                    <p class="vstitle">{{item.express_name}}</p>
                    <p>{{item.express_no}}</p>
                </div>
            </div>
          
            <div class="InfoSelf-box" style="border: none;">
                <el-button type="primary" v-if="(!(vsData.ispay=='1'))" @click="handleQuick">去付款</el-button>
                <el-button type="primary" v-if="(vsData.isexpress=='1')&&(vsData.isconfirm=='g')&&(vsData.itemispay=='1')" round>收货</el-button>
            </div>
        </div>
            
    </div>

</template>
<script>
import { getTimeDate } from '../../js/getTime.js'
export default{
    data(){
        return{
            vsData: [],
            order_express: [],
            isOAdd: '',
            isAdd: '',
            econtact: '',
            ephone: '',
            eaddress: '',
            eprovince: '',
            eprovincev: '',
            ecity: '',
            ecityv: '',
            ecounty: '',
            ecountyv: '',
            vspn:0,
            expressList: [],
            invoiceAddress: [],
            invoiceInfo: []
        }
    },
    methods: {

        getExpress(){
            let enable = {
                pageNum: '1' ,
                pageSize: '999',
                expressCom: this.order_express[0].express_value,
                expressNo: this.order_express[0].express_no,
                expressPhone: this.ephone
            }
            this.$store.dispatch('enable/getExpress',enable)
                .then(res => {
                    if(res.ok){
                        if(res.data.result){
                            var items = res.data.data
                            var dpn = items.length
                            this.vspn = dpn
                            if(dpn > 0){
                                for(var i=0;i<dpn;i++){
                                    this.expressList.push(items[i])
                                }

                                this.expressList.forEach(item => {
                                    item.ftime = getTimeDate(item.ftime)
                                });
                            }
                        }
						
					}
                })
        },
        handleQuick(){
            this.$router.push({
                path: '/checkoutQuick',
                query: {
                    order: this.$route.query.order_no
                }
                })
        }
    },
    mounted(){
        let data = {
            order_no: this.$route.query.order_no
        }
        this.$store.dispatch('personal/infoSelf',data)
            .then(res => {
                if(res.ok){
                    console.log('getDetail')
                    var info = res.data
                    console.log(info)
                    this.vsData = res.data
                    
                    this.vsData.create_time = getTimeDate(this.vsData.create_time)
                    this.vsData.pay_time = getTimeDate(this.vsData.pay_time)
                    this.invoiceAddress = ''
                    this.invoiceInfo = ''
                    var contact=info.contact
                    if(this.vsData.invoiceAddressInfo != ''){
                        this.invoiceAddress = this.vsData.invoiceAddressInfo
                        this.invoiceInfo = this.vsData.invoiceInfo
                    }
                    this.order_express = info.order_express
                    var dpn = this.order_express.length
                    this.vspn = dpn
                    if(dpn > 0){
                        for(var i=0;i<dpn;i++){
                            this.expressList.push(this.order_express[i])
                        }

                      
                    }

                    if(!(contact=='')){
                        this.isOAdd='1'
                        this.isAdd='1'
                        
                        this.econtact=info.contact
                        this.ephone=info.phone
                        this.eaddress=info.address
                        this.eprovince=info.province_code
                        this.eprovincev=info.province_name
                        this.ecity=info.city_code
                        this.ecityv=info.city_name
                        this.ecounty=info.county_code
                        this.ecountyv=info.county_name
                    }
                }
            })
        
        // let invoice_address_id = this.$route.query.invoice_address_id
        // let invoice_id = this.$route.query.invoice_id

        // if(invoice_id != 0){
        //     let data = {
        //         id : invoice_id
        //     }
        //     this.$store.dispatch('personal/invoiceInfo',data)
        //         .then(res => {
        //             if(res.ok){
        //                 this.invoiceInfo = res.data
        //             }
        //         })
        // }

        // if(invoice_address_id != 0){
        //     let data = {
        //         id: invoice_address_id
        //     }

        //     this.$store.dispatch('personal/addressInfo',data)
        //         .then(res => {
        //             if(res.ok){
        //                 this.invoiceAddress = res.data
        //             }
        //         })
        // }
    }
}
</script>

<style scoped lang="scss">
@import url(../../css/personalInfo.css);

.vstips{
    margin-top: 10px;
    font-size: 16px;
    color: #666666
}
.vstitle{
    font-size: 16px;
    color: #333333;
}
.invoiceCss{
    width: 900px;
   
    font-size: 18px;
    padding: 20px 20px;
    margin: 10px auto;
    margin-bottom: 30px;
    border-bottom: 0.5px solid #f2f2f2;
    .invoice_box{
        div{
            display: flex;
            justify-content: space-between;
            align-items: center;
            line-height: 50px;
            span{
                color: #10aeff;
            }
        }
        
    }
}
</style>